import React, { useEffect } from 'react'
import AuthLayout from '../../../layout/AuthLayout'
import { Box } from '@mantine/core'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../store/dataRoute'
import DashboardCount from '../../../component/pages/Dashboard/DashboardCount'

const Dashboard = () => {
  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Dashboard',
      route: null
    }
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <AuthLayout>
      <Box my={20}>
        <DashboardCount />
      </Box>
    </AuthLayout>
  )
}

export default Dashboard